/* eslint-disable no-param-reassign, import/no-cycle */
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { get } from '../../../services/GenesisApi';
import { PRODUCER_CONFIG } from '../../../constants/ProducerConfig';
import { IProducerConfig } from '../../../types/ProducerConfig.type';
import { COMMON_MESSAGES } from '../../../constants/Common';

export interface IProducerConfigState {
  loadingProducerConfig: boolean;
  producerConfig: IProducerConfig[];
  loadingProducerConfigDetails: boolean;
  producerConfigDetails: IProducerConfig | null;
}

export const initialState: IProducerConfigState = {
  loadingProducerConfig: false,
  producerConfig: [],
  loadingProducerConfigDetails: false,
  producerConfigDetails: null,
};

export const getAllProducerConfig = createAsyncThunk(
  'producerConfig/getAllProducerConfig',
  async () => {
    return get(PRODUCER_CONFIG, {})
      .then((response) => {
        const data = response.data || [];
        return data.map((_) => ({
          ..._,
          status: _.isActive ? 'Active' : 'Inactive',
        }));
      })
      .catch((error) => {
        throw error;
      });
  }
);

const ProducerConfig = createSlice({
  name: 'producerConfig',
  initialState,
  reducers: {
    updateField: (state, action) => {
      if (state?.producerConfigDetails) {
        const { field, value } = action.payload;
        state.producerConfigDetails[field] = value;
      }
    },
    setProducerConfigDetails: (state, action) => {
      let data = action.payload;
      data = {
        ...data,
        cvaList: data?.cvaList?.map((_) => {
          return {
            ..._,
            isActive: true,
            fieldId: uuidv4(),
            references: _.references.map((reference) => ({
              ...reference,
              isActive: true,
              fieldId: uuidv4(),
            })),
          };
        }),
      };
      state.producerConfigDetails = data;
    },
    resetProducerConfigDetails: (state) => {
      state.producerConfigDetails = {
        producerId: 0,
        producerName: '',
        counterpartyName: 'SHELL',
        counterpartyCode: 'TSEE',
        transactionType: 'A',
        subTerminalName: '',
        subTerminalId: null,
        cvaList: [
          {
            id: 0,
            isActive: true,
            period: dayjs().format(COMMON_MESSAGES.DATE_YYYY_MM_DD),
            fieldId: uuidv4(),
            references: [
              {
                referenceId: 0,
                name: '',
                percentage: 100,
                isActive: true,
                fieldId: uuidv4(),
              },
            ],
          },
        ],
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllProducerConfig.pending, (state: IProducerConfigState) => {
        state.loadingProducerConfig = true;
        state.producerConfig = [];
      })
      .addCase(
        getAllProducerConfig.fulfilled,
        (
          state: IProducerConfigState,
          { payload }: PayloadAction<IProducerConfig[]>
        ) => {
          state.producerConfig = payload;
          state.loadingProducerConfig = false;
        }
      )
      .addCase(getAllProducerConfig.rejected, (state: IProducerConfigState) => {
        state.loadingProducerConfig = false;
      });
  },
});

export const producerConfigActions = ProducerConfig.actions;
export default ProducerConfig.reducer;
